import { createElement } from 'react';
import PropTypes from 'prop-types';

import { createComponentFactory } from 'fela';

export default createComponentFactory(createElement, {
  renderer: PropTypes.object,
  theme: PropTypes.object
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-fela/es/createComponent.js
// module id = 753
// module chunks = 0